<template>
    <multiselect
            v-model="subscribers"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            :options="users"
            mode="tags"
            max="1"
            open-direction="top"
            :object="true"
            value-prop="full_name"
            track-by="id"
            placeholder="Who will be notified"
            label="full_name"
            @input="$emit('submitting', true)"
            class="input"
            style="width: 230px !important;"
    />
<!--  <multicomplete type="user" placeholder="Select a User" track="id" field-name="full_name" v-model="subscribers" />-->

</template>

<script>
    import Subscribers from '../mixins/Subscribers'
    import multiselect from "@vueform/multiselect";

    export default {
        mixins: [Subscribers],
        components: {
            multiselect
        },

        watch: {
            subscribers: {
                deep: true,
                handler() {
                    if (!this.dataLoaded) return

                    // defer the subscribers update
                    if (this.syncTimeout) {
                        clearTimeout(this.syncTimeout)
                    }

                    this.syncTimeout = setTimeout(() => {
                        this.handleUpdate()
                    }, 3000)
                }
            }
        },

        beforeDestroy() {
            if (this.syncTimeout) {
                clearTimeout(this.syncTimeout)
            }

            this.handleUpdate()
        }
    }
</script>
